// Module
var code = `<div class="page"> <div class="page_content"> <span class="panel_title">BOOKMARKED #CATEGORY</span> <div class="panel" id="no_bookmarks_panel"> You have no bookmarks. </div> <div id="bookmark_container"> </div> </div> </div>`;
// Exports
export default code;